'use strict';

const Backbone = require('backbone/backbone');

require('./IndexHeroPortrait.less');

module.exports = Backbone.View.extend({

    el: '.IndexHeroPortrait',

    initialize: function () {
    }
});
